// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"199661b4","703":"b31065a1","787":"2fdf6726"}[chunkId] + ".chunk.js";
};